<template>
  <div
    v-if="notice && open"
    class="fixed inset-0 w-full h-full bg-black/50 z-50 flex items-center justify-center"
  >
    <div class="w-fit relative z-50">
      <i
        @click="closeNotice()"
        class="fa-solid cursor-pointer fa-xmark absolute top-10 right-14 text-gray-900 text-2xl z-50"
      ></i>
      <div
        class="w-full bg-white text-gray-700 p-8 m-8 rounded shadow-md max-w-lg overflow-auto max-h-[500px] relative"
      >
        <div v-html="notice" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: function () {
    return {
      open: true,
      notice: null,
    };
  },
  async mounted() {
    try {
      const op = await axios.get(
        `https://api-gabarit.promo.dev/api/v2/formdata/6ab5213da6298f733bc73670`
      );

      this.notice = op.data.custom.notice;
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    closeNotice() {
      this.open = false;
      this.$emit("close");
    },
  },
};
</script>
